// Installs the I18n global that @morsedigital/i18n_helper calls through.
// The layout follows this tag with an inline script setting I18n.locale, so
// this entry must stay blocking rather than deferred.
import I18n from '../vendor/i18n';
import translations from '../i18n/translations.json';

I18n.translations = translations;

window.I18n = I18n;
